import { connect } from 'react-redux';
import { withRouter } from 'react-router-dom';

import Memberbodies from './Memberbodies';

const mapStateToProps = (state, ownProps) => ({ ...ownProps });

export default withRouter(connect(mapStateToProps)(Memberbodies));
